// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import useEffectOnce from "../hooks/useEffectOnce";
import { insertUserProperty } from "../helpers/analytics";
import { WEB_BASE_URL } from "../constants";

function Seo({ description, lang = "en", meta = [], title, image, titleTemplate = `%s | Whereby` }) {
    useEffectOnce(() => {
        // Get any active experiments from google optimize
        global.gtag?.("event", "optimize.callback", {
            callback: (value, name) => {
                value && name && insertUserProperty("experiments", `${name}_${value}`);
            },
        });
    });

    const metaDescription =
        description ||
        "Easy video meetings with no login or downloads. Video conferencing with screen sharing, recording and much more.";
    const base = __PATH_PREFIX__;

    if (image && image.indexOf("//") === 0) {
        image = `https:${image}`;
    }

    return (
        <Helmet
            base={{
                href: WEB_BASE_URL,
            }}
            htmlAttributes={{ lang, prefix: "og: http://ogp.me/ns#" }}
            title={title}
            titleTemplate={titleTemplate}
            meta={[
                { name: `description`, content: metaDescription },
                { property: `fb:app_id`, content: `1411558269071152` },
                { property: `og:description`, content: metaDescription },
                { property: `og:image`, content: image || `${base}/facebook-opengraph.png` },
                { property: `og:title`, content: title || `Whereby` },
                { property: `og:type`, content: `website` },
                { name: `twitter:card`, content: `summary_large_image` },
                { name: `twitter:description`, content: metaDescription },
                { name: `twitter:image`, content: image || `${base}/icon-redbird.png` },
                { name: `twitter:site`, content: `@Whereby` },
                { name: `twitter:title`, content: title || `Whereby` },
            ].concat(meta)}
            link={[
                { rel: "icon", href: `${base}/favicon.png`, type: "image/png" },
                { rel: "icon", href: `${base}/favicon.svg`, type: "image/svg+xml" },
                { rel: "apple-touch-icon", href: `${base}/apple-touch-icon.png` },
            ]}
        />
    );
}

Seo.propTypes = {
    description: PropTypes.string,
    image: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            content: PropTypes.string,
            property: PropTypes.string,
        })
    ),
    title: PropTypes.string,
    titleTemplate: PropTypes.string,
};

export const EmbeddedSeo = ({ description, ...restProps }) => (
    <Seo
        {...restProps}
        titleTemplate={`%s | Whereby Embedded`}
        description={
            description ||
            "Enhance your customer experience with video meetings - Use our simple API to embed video meetings in your website or app with Whereby Embedded."
        }
    />
);

if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-unused-vars
    const { titleTemplate, ...restPropTypes } = Seo.propTypes;
    EmbeddedSeo.propTypes = restPropTypes;
}

export default Seo;
